// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DMqC2","delete":"styles_delete__2qHc9","update":"styles_update__3fAle","add":"styles_add__18vod"};